// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.33073 13.5352C2.32574 12.8625 1.66406 11.7168 1.66406 10.4167C1.66406 8.46369 3.15699 6.85941 5.06385 6.68281C5.45391 4.31011 7.51427 2.5 9.9974 2.5C12.4805 2.5 14.5409 4.31011 14.9309 6.68281C16.8378 6.85941 18.3307 8.46369 18.3307 10.4167C18.3307 11.7168 17.6691 12.8625 16.6641 13.5352M6.66406 13.3333L9.9974 10M9.9974 10L13.3307 13.3333M9.9974 10V17.5"
    />
  </svg>
);
const IconUploadCloud = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUploadCloud;
